import {API_URLS} from '@/const';
import {http, timeUtil} from '@/helper';

export const downloadApi = {
  getContractOrder(query) {
    return http.get(API_URLS.DOWNLOAD_CONTRACT_ORDER, {query});
  },
  getContractOrderV2(query) {
    return http.get(API_URLS.DOWNLOAD_CONTRACT_ORDER_V2, {query});
  },
  getContractTrade(query) {
    return http.get(API_URLS.DOWNLOAD_CONTRACT_TRADE, {query});
  },
  getContractTradeV2(query) {
    return http.get(API_URLS.DOWNLOAD_CONTRACT_TRADE_V2, {query});
  },
  getSpotOrder(query) {
    return http.get(API_URLS.DOWNLOAD_SPOT_ORDER, {
      query,
      formatter(data) {
        const {total, rows} = data;
        rows.forEach((row) => {
          row.time = timeUtil.formatUTCDateTime(row.createTimeNs * 1e-6);
          delete row.createTimeNs;
        });
        return {total, rows};
      },
    });
  },
  getSpotTrades(query) {
    return http.get(API_URLS.DOWNLOAD_SPOT_TRADES, {
      query,
      formatter(data) {
        const {total, rows} = data;
        rows.forEach((row) => {
          row.time = timeUtil.formatUTCDateTime(row.transactTimeNs * 1e-6);
          delete row.transactTimeNs;
        });
        return {total, rows};
      },
    });
  },
  getWalletDetails(query) {
    return http.get(API_URLS.DOWNLOAD_WALLET_DETAILS, {
      query,
      formatter(data) {
        const {total, rows} = data;
        rows.forEach((row) => {
          row.time = timeUtil.formatUTCDateTime(row.transactTimeNs * 1e-6);
          delete row.transactTimeNs;
        });
        return {total, rows};
      },
    });
  },
  getDeposit(query) {
    return http.get(API_URLS.DOWNLOAD_DEPOSIT, {
      query,
      formatter(data) {
        const {total, rows} = data;
        rows.forEach((row) => {
          row.time = timeUtil.formatUTCDateTime(row.createdAt);
          delete row.createdAt;
        });
        return {total, rows};
      },
    });
  },
  getWithdraw(query) {
    return http.get(API_URLS.DOWNLOAD_WITHDRAW, {
      query,
      formatter(data) {
        const {total, rows} = data;
        rows.forEach((row) => {
          row.time = timeUtil.formatUTCDateTime(row.submitedAt);
          delete row.submitedAt;
        });
        return {total, rows};
      },
    });
  },
  getOfflineDownload(query) {
    return http.get(API_URLS.OFFLINE_DOWNLOAD_QUERY, {query});
  },
  getLimitCheckOfflineDownload(query) {
    return http.get(API_URLS.OFFLINE_DOWNLOAD_LIMIT_CHECK, {query});
  },
  createOfflineDownload(params) {
    return http.post(API_URLS.OFFLINE_DOWNLOAD_CREATE, {params});
  },
  getKolClientExport(query) {
    return http.get(API_URLS.KOL_CLIENT_EXPORT_QUERY, {query});
  },
  getKolClientCsv(query) {
    return http.get(API_URLS.KOL_CLIENT_EXPORT_CSV, {query, responseType: 'blob'});
  },
  creatKolClientFile(params) {
    return http.post(API_URLS.KOL_CLIENT_EXPORT_APPLY, {params});
  },
};
